export default {
    data() {
        return {
          errors: false,
          message: "",
        };
    },
    methods: {
         /**
     * 获取共享桌面错误状态
     */
    displayMediaErrorState() {
        let states = {
          NotAllowedError: () => {
            this.errors = true;
            this.message = this.$t("share.请前往系统设置中允许当前浏览器访问屏幕共享");
          },
          success: () => {
            this.errors = false;
            this.message = "";
          }
        };
        return {
          show: (result) => {
            states[result] && states[result]();
          },
        };
      },
      /**
       * 摄像头获取错误显示
       */
       getDisplayMediaError(name) {
        this.displayMediaErrorState().show(name);
      },
    }
}